export const breadcrumb = {
  title: 'Autoinformer',

  campaign: {
    index: 'Kampanye',
    edit: 'Edit kampanye',
    new: 'Tambah kampanye',
    tasks: 'Tugas {name}'
  },

  tasks: { create: 'Membuat tugas' }
};
